import { constants } from "../../misc/constants";
import Scenario2 from "./Scenario2";
import { SbarUIConfig } from "../../components/ui/SbarUI";
import { FullPageQuizQuestion } from "../../components/ui/FullPageQuizUI";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario2Part3 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-2-1',
        chapterCinematic3: 'medsurg-cinematic-2-3',
        chapterCinematic6: 'medsurg-cinematic-2-6',
        chapterCinematic7: 'medsurg-cinematic-2-7',
        chapterCinematic8: 'medsurg-cinematic-2-8',
        chapterCinematic9: 'medsurg-cinematic-2-9',
        chapterCinematic10: 'medsurg-cinematic-2-10',
		chapterCinematic11: 'medsurg-cinematic-2-11',
        chapterCinematic12: 'medsurg-cinematic-2-12',
		//NEED FAIL ANIMS (4 ANIMATIONS)
		chapterCinematic96: 'medsurg-cinematic-2-96',
        chapterCinematic97: 'medsurg-cinematic-2-97',
        chapterCinematic94: 'medsurg-cinematic-2-94',
		chapterCinematic95: 'medsurg-cinematic-2-95',
        chapterCinematic14: 'medsurg-cinematic-2-14', //prov mask
        chapterCinematic77: 'medsurg-cinematic-2-77', //mask
		//NEED REBREATHER ANIM
	}

	constructor(scenario: Scenario2, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private ActionInstanceID2: string;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Talk4: boolean = false;
	private Talk5: boolean = false;
	private Talk6: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action3: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;
	private PObool: boolean = false;
	private rebreatherChanged: boolean = false;
	
	private avatar1: boolean = false;
	private avatar2: boolean = false;
	private avatar3: boolean = false;
	private avatar4: boolean = false;

	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part3.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario2/video3' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario2/video30.mp4'];
	}

	public start() {
		const context = this;
		if(this.scenario.avatarIndx === 0) {
			this.avatar1 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 1) {
			this.avatar2 = true;
			this.avatar1 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 2) {
			this.avatar3 = true;
			this.avatar2 = false;
			this.avatar1 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 3) {
			this.avatar4 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar1 = false;
		}
		this.RememberDisplayed = false;
		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			// context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		context.scenario.hideFooter();
        this.scenario.displayModalPop(
			null,
            'Skipping to part 4',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            "It's time to visit Mr. Roth in room 4.",
            () => {
				this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				context.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '6', '3', false, false);
				context.TalkCount = 6;
				context.ActionCount = 3;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeOut();
		context.scenario.displayDebrief(9250, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
        context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.onDone();
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = (this.scenario as Scenario2).PrRothID;
		context.scenario.gameManager.UiManager.updateUIInstance(this.PrInstanceID, {
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			}
		})

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario2).PrRothID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'Can you tell me your name?',
					onClicked: () => {
						this.segment1TalkName();
					},
					disable: () => this.Talk3
				},
				{
					toppx: '350px',
					titletext: 'Do you know what day it is?',
					onClicked: () => {
						this.segment1TalkDay();
					},
					disable: () => this.Talk4
				},
				{
					toppx: '450px',
					titletext: "Do you know where you are?",
					onClicked: () => {
						this.segment1TalkWhere();
					},
					disable: () => this.Talk5
				},
				{
					toppx: '550px',
					titletext: "Do you know why you're here today?",
					onClicked: () => {
						this.segment1TalkWhy();
					},
					disable: () => this.Talk6
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				},
				{
					toppx: '150px',
					titletext: 'Change to Non-Rebreather Mask',
					onClicked: () => {
						this.segment1ActionMask();
					},
					disable: () => this.Action2
				},
				{
					toppx: '250px',
					titletext: 'Assess Patient Condition',
					onClicked: () => {
						this.segment1ActionAssess();
					},
					disable: () => this.Action3
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '70px',
			loadQuiz: true,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "I feel... I don't know... I feel... so... weak. Something's not right...",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 550,
					talktext1: 'Patient Observation',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'No active problems',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Weak',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Nausea',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Trembling',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Lethargic',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Chills',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: "Doesn't feel right",
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 3,
					prequizheight: 7,
					quiztop: '520px',
					maxPoints: 250,
					talktext1: 'Patient Observation',
					talktext2: 'Breathing',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Eupneic',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Tachypneic',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Apneic',
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 4,
					prequizheight: 13,
					quiztop: '775px',
					maxPoints: 250,
					talktext1: 'Patient Observation',
					talktext2: 'Patient Demeanor',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Calm',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Aggressive',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Anxious',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Restless',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic6, () => {
			if(this.rebreatherChanged) {
				this.playVideoChapter(this.chapterIds.chapterCinematic77, () => {}, true); //NEED REBREATHER ANIM, CHANGE CINEMATIC LEFT TO REBREATHER LOOP
			} else this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '170px',
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 200,
			painScaleCorrect: 0,
			extBottom: true,
			extText: "No... I don't think so... no pain?",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic7, () => {
			if(this.rebreatherChanged) {
				this.playVideoChapter(this.chapterIds.chapterCinematic77, () => {}, true); //NEED REBREATHER ANIM, CHANGE CINEMATIC LEFT TO REBREATHER LOOP
			} else this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1TalkName() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Can you tell me your name?',
			isTalks: true,
			extBottom: true,
			extText: "Um, yeah... It's Joe.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: ' ',
					talktext2: 'Mental State',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Alert',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Oriented',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Confused',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Incoherent',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Nonresponsive',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic8, () => {
			if(this.rebreatherChanged) {
				this.playVideoChapter(this.chapterIds.chapterCinematic77, () => {}, true); //NEED REBREATHER ANIM, CHANGE CINEMATIC LEFT TO REBREATHER LOOP
			} else this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1TalkDay() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '370px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Do you know what day it is?',
			isTalks: true,
			extBottom: true,
			extText: "Thursday?",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk4 = true;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.TalkCount = this.OldTalkCount - 1;
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: ' ',
					talktext2: 'Mental State',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Alert',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Oriented',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Confused',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Incoherent',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Nonresponse',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);

		context.scenario.displayModalPop(
			null,
            'Today is Tuesday.',
            () => {
				context.scenario.update508Window(Window508Type.TransformUI);
                context.scenario.endModalPop();
				this.playVideoChapter(this.chapterIds.chapterCinematic9, () => {
					if(this.rebreatherChanged) {
						this.playVideoChapter(this.chapterIds.chapterCinematic77, () => {}, true); //NEED REBREATHER ANIM, CHANGE CINEMATIC LEFT TO REBREATHER LOOP
					} else this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
				});
            }
        );
	}

	private segment1TalkWhere() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '470px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Do you know where you are?',
			isTalks: true,
			extBottom: true,
			extText: "Um... in bed, but it's not my bed...",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk5 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: ' ',
					talktext2: 'Mental State',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Alert',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Oriented',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Confused',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Incoherent',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Nonresponsive',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic10, () => {
			if(this.rebreatherChanged) {
				this.playVideoChapter(this.chapterIds.chapterCinematic77, () => {}, true); //NEED REBREATHER ANIM, CHANGE CINEMATIC LEFT TO REBREATHER LOOP
			} else this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1TalkWhy() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '570px',
			scenario: this,
			loadQuiz: true,
			titletext: "Do you know why you're here today?",
			isTalks: true,
			extBottom: true,
			extText: "I don't know... I need to sleep?",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk6 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: ' ',
					talktext2: 'Mental State',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Alert',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Oriented',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Confused',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Incoherent',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Nonresponsive',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -500px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic11, () => {
			if(this.rebreatherChanged) {
				this.playVideoChapter(this.chapterIds.chapterCinematic77, () => {}, true); //NEED REBREATHER ANIM, CHANGE CINEMATIC LEFT TO REBREATHER LOOP
			} else this.playVideoChapter(this.chapterIds.chapterCinematic3, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '101.2',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
					list: '<li>Temperature : 101.2</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Blood Pressure',
			vitaltext: '100/60',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
					list: '<li>Blood Pressure : 100/60</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '110',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
					list: '<li>Pulse : 110</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Respirations',
			vitaltext: '28',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
					list: '<li>Respirations : 28</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			scenario: this,
			titletext: 'O2 Sat Level',
			vitaltext: '90% 2L supplemental O2',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).rothVitalsID, {
					list: '<li>02 Sat Level : 90% 2L supplemental O2</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionMask() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Change to Non-Rebreather Mask',
			scenario: this,
			isTalks: true,
			onSubmit: () => {
				this.Action2 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.gameManager.environment.blurFadeIn();
				context.scenario.updateScore(250);
				setTimeout(() => {
					this.rebreatherChanged = true;
					this.playVideoChapter(this.chapterIds.chapterCinematic77, () => {}, true); //NEED REBREATHER ANIM, CHANGE CINEMATIC LEFT TO REBREATHER LOOP
				}, 1000)
				setTimeout(() => {
					context.scenario.gameManager.environment.blurFadeOut();
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1500);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);			
				context.getFooterCounts();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionAssess() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '270px',
			titletext: 'Assess Patient Condition',
			isTalks: true,
			scenario: this,
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			context.showFullPageQuiz();
		}, 2200);
	}

	private showFullPageQuiz() {
		var context = this;
		context.scenario.hideFooter();
		context.scenario.update508Window(Window508Type.FullPageQuiz)
		var FPinstance = this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.FullPageQuizUI, {
			questions: [
				{
					title: 'What do you want to assess for?',
					options: [
						{
							title: 'Sepsis',
							isCorrect: true,
							points: 250
						},
						{
							title: 'Pneumonia',
							isCorrect: false,
							points: 0
						},
						{
							title: 'Meningitis',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Although that is a realistic suspicion, that is not what is happening in this scenario. Please try again.'
				},
				{
					title: "Is the patient's history suggestive of a new infection?",
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 250
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient was admitted with pneumonia. Please try again.'
				},
				{
					title: 'Has the patient recently begun to exhibit at least two of the following signs and symptoms of infection?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 250
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient has started to exhibit some of these signs and symptoms. Please try again.',
					left: true,
					leftText: "<ul><li>Altered mental status</li><li>Tachypnea greater than20 bpm</li><li>Hyperthermia greater than 38.3&degC (101.0&degF)</li><li>Hypothermia less than 36&degC (96.8&degF)</li><li>Tachycardia greater than 90 bpm</li><li>Leukocytosis (WBC count greater than 12,000 &microL-1)</li><li>Leukopenia (WBC count less than 4,000 &microL-1)</li><li>Hyperglycemia (plasma glucose less than 140 mg/dL) or 7.7 mmol/L in the absence of diabetes</li></ul>",
					leftTop: '30%'
				},
				{
					title: 'Based on your assessment, which labs would you anticipate the provider to order?',
					multipleChoice: true,
					options: [
						{
							title: "Don't order labs",
							isCorrect: false,
							points: 0
						},
						{
							title: 'Lactic acid',
							isCorrect: true,
							points: 420
						},
						{
							title: 'Blood cultures',
							isCorrect: true,
							points: 415
						},
						{
							title: 'CBC with differential',
							isCorrect: true,
							points: 415
						},
						{
							title: 'Basic chemistry labs',
							isCorrect: false,
							points: 0
						},
						{
							title: 'Bilirubin',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'The following labs are incorrect: <ul><li>Chemistry labs </li><li> Bilirubin </li></ul>'
				},
				{
					title: 'Are any of the following organs dysfunctional criteria present at a site remote from the site of infection that are NOT considered to be chronic conditions?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 250
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Please review labs and try again.',
					right: true,
					rightText: "<ul><li>SBP less than 90 mmHg or MAP less than 65 mmHg</li><li>SBP decrease greater than 40 mm Hg from baseline</li><li>Creatinine greater than 2.0 mg/dl (176.8 mmol/L) or urine output less than 0.5 ml/kg/hour for 2 hours</li><li>Bilirubin greater than 2 mg/dl (34.2 mmol/L)</li><li>Platelet count less than 100,000 μL</li><li>Lactate greater than 2 mmol/L (18.0 mg/dl)</li><li>Coagulopathy (INR greater than 1.5 or aPTT greater than 60 secs)</li><li>Acute lung injury with PaO2/FiO2 less than 250 in the absence of pneumonia as infection source</li><li>Acute lung injury with PaO2/FiO2 less than 200 in the presence of pneumonia as infection source</li></ul>",
					leftImg: 'table1',
					leftTop: '30%'
				},
				{
					title: 'If suspicion of infection is present AND organ dysfunction is present, should the patient be entered into the SEPSIS protocol?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 250
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'This answer is incorrect. Please try again.',
					left: true,
					leftText: "New evidence improves our understanding of how to care for patients of sepsis. The sepsis campaign executive committee recommends the following bundle:<br><br>The Sepsis bundle should be completed within 3 hours of time of presentation, including:<ul><li>Measure lactate level</li><li>Obtain blood cultures prior to administration of the antibiotics</li><li>Administer broad spectrum antibiotics</li><li>Administer 30 mL/kg crystalloid for hypotension or lactate greater than or equal to 4mmol/L</li></ul>",
					leftTop: '30%'
				},
				{
					title: 'Based on the information below, what is the recommended IV rate for crystalloid for your patient (he weighs 175 lbs. (80 kg))?',
					options: [
						{
							title: '1,250 mL',
							isCorrect: false,
							points: 0
						},
						{
							title: '2,400 mL',
							isCorrect: true,
							points: 250
						},
						{
							title: '5,000 mL',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Please try again. Remember that the formula is 30 mL/kg per hour.',
					center: true,
					centerText: "30 mL/kg per hour",
					leftTop: '40%'
				},
				{
					title: 'Based on your assessment, which labs would you anticipate the provider to order?',
					options: [
						{
							title: "Contact Provider",
							isProv: true,
							isFail: false,
							points: 0
						},
						{
							title: 'Exit room',
							isFail: true,
							isProv: false,
							points: 0
						},
						{
							title: 'Update charge nurse',
							isFail: true,
							isProv: false,
							points: 0
						}
					],
					incorrectFeedback: 'Incorrect'
				}
			],
			onSingleQuestionSubmitted: (question: FullPageQuizQuestion) => {
				var correctOptions = question.options.filter(o => o.isCorrect);

				var correctPoints = 0;
				correctOptions.forEach(co => correctPoints += co.points);

				var selectedOptions = question.options.filter(o => o.isSelected);
				var correctSelectedOptions = question.options.filter(o => o.isCorrect && o.isSelected);
				var isCorrect = correctOptions.length === correctSelectedOptions.length && selectedOptions.length === correctOptions.length;
				var provOption = question.options.filter(o => o.isProv);
				var provSelectedOption = question.options.filter(o => o.isProv && o.isSelected);
				var failOption = question.options.filter(o => o.isFail);
				var failSelectedOption = question.options.filter(o => o.isFail && o.isSelected);
				var isProv = provOption.length === provSelectedOption.length && selectedOptions.length === provOption.length;
				var isFailed = failOption.length === failSelectedOption.length && selectedOptions.length === failOption.length;
				if(isProv) {
					context.scenario.updateScore(1000);
				}
				else if(isFailed) {
					this.scenario.gameManager.UiManager.hideUiInstance(FPinstance);
					context.segment2ActionFail();
				}
				else if(isCorrect) {
					context.scenario.updateScore(correctPoints);
				}
				else {
					this.scenario.gameManager.UiManager.hideUiInstance(FPinstance);
					this.scenario.showFeedback(question.incorrectFeedback, () => {
						this.scenario.gameManager.UiManager.showUiInstance(FPinstance);
						this.scenario.update508Window(Window508Type.FullPageQuiz)
					})
				}

				return isCorrect || isProv
			},
			onDone: () => {
				context.scenario.update508Window(Window508Type.TalkActionsUI)
				context.scenario.gameManager.UiManager.destroyUIInstanceById(FPinstance);
				context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
				context.segment1PartEndingStart();
			}
		});	
	}

	private segment2ActionFail() {
		var context = this;
		this.scenario.gameManager.environment.blurFadeIn();
		this.scenario.displayModalPop(
			null,
            "Your patient has had an adverse event. Please report to the nurses’ station to speak with your charge nurse.",
            () => {
                context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
				context.scenario.updateFooter('0', '0', true, true);
				context.scenario.hideFooter();
				context.segment2ActionChargeNurse();
            }
        );
	}

	private segment2ActionChargeNurse() {
		var context = this;
		//NEED FAIL ANIM, CHANGE CHAPTERCINEMATICS BELOW TO EACH PLAYER CHARACTER LOOP
		if(this.avatar1) {
			this.playVideoChapter(this.chapterIds.chapterCinematic96, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar2) {
			this.playVideoChapter(this.chapterIds.chapterCinematic97, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar3) {
			this.playVideoChapter(this.chapterIds.chapterCinematic94, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar4) {
			this.playVideoChapter(this.chapterIds.chapterCinematic95, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		}
		setTimeout(() => {
			context.segment2ActionChargeNurseNext();
		}, 1000);
	}

	private segment2ActionChargeNurseNext() {
		var context = this;
		//context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.showRemediation(
			'I would like to discuss Mr. Roth’s situation. It is always important to keep the Provider updated on the patient’s condition, and to let him or her know when you suspect a serious condition. Delaying the intervention could result in further deterioration of your patient. Please return to Room #4 and begin caring for your patient again.',
			'./assets/images/general/icons/npc-headshots/ChargeNurse.png',
			() => {
				context.scenario.gameManager.environment.blurFadeOut();
				localStorage.setItem('ignoreResumePopup', 'true');
				window.location.reload();
			}
		)
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.update508Window(Window508Type.Main);
			//context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			//context.segment1StepFinal();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);	
			this.Action1 = true;
			this.ActionCount = this.OldActionCount - 1;
		};
		context.getFooterCounts();
	}

	private segment1PartEndingStart() {
		var context = this;
		if(this.rebreatherChanged) {
			this.playVideoChapter(this.chapterIds.chapterCinematic14, () => {
				context.scenario.gameManager.environment.blurFadeIn();
			}); //NEED REBREATHER ANIM, CHANGE CINEMATIC LEFT TO REBREATHER LOOP
		} else {
			this.playVideoChapter(this.chapterIds.chapterCinematic12, () => {
				context.scenario.gameManager.environment.blurFadeIn();
			});
		}
		context.scenario.showProvider(
			"Hi Nurse, what's the situation?",
			() => {
				context.segment3showSbar();
			}
		);
	}

	private segment3showSbar() {
		var context = this;
		context.scenario.update508Window(Window508Type.SbarUI)
		this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.SbarUI, {
			s: {
				maxPoints: 250,
				options: [
					{
						text: 'Suspect Sepsis',
						isCorrect: true
					},
					{
						text: 'Poor O2 sat',
						isCorrect: true
					},
					{
						text: 'Fever',
						isCorrect: true
					},
					{
						text: 'Sweating',
						isCorrect: false
					},
					{
						text: 'Declining vitals',
						isCorrect: true
					},
					{
						text: 'Confusion',
						isCorrect: true
					},
					{
						text: 'Nausea',
						isCorrect: false
					}
				]
			},
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).rothBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).rothNursesID),
			r: {
				maxPoints: 250,
				options: [
					{
						text: 'Medication',
						isCorrect: true
					},
					{
						text: 'Transfer to ICU',
						isCorrect: true
					},
					{
						text: 'CT Scan',
						isCorrect: false
					}
				]
			},
			correctFeedback: 'Good job, you have correctly relayed critical information. Please review the SBAR and continue.',
			incorrectFeedback: 'You have incorrectly relayed critical information. Accurate patient information ensures patient safety and quality care provided by medical staff and Providers. Please continue to review the corrected SBAR.',
			onSubmitted: (result: SbarUIConfig) => {
				this.scenario.evaluateScoreForSbar(result);
			},
			onClose: (result: SbarUIConfig) => {
				context.scenario.destroyAllUIInstances();
				context.scenario.showProvider(
					"I agree sepsis is a strong possibility. Let's transfer Mr. Roth to ICU where he can be monitored more closely.",
					() => {
						context.segment1Part5Debrief();
					}
				);
			},
			onSetWindow: (window: Window508Type) => {
				context.scenario.update508Window(window);
			}
		});
	}
}